<template>
  <div class="wrapper" v-if="goodsinfo">
    <div class="top">
      <div class="topCommodity">
        <div class="commodity">
          <div style="display:flex">
            <img :src="goodsinfo.commodity_logo" alt />
            <div class="rightArea">
              <span class="more-h commodityName">{{goodsinfo.commodity_name}}</span>
              <span class="more-h property">规格：{{goodsinfo.property}}</span>
              <div class="last">
                <span class="price">￥{{parseFloat(goodsinfo.sell_price)}}</span>
                <span class="quantity">x{{goodsinfo.quantity}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="moneybox">
        <div class="moneyboxtop" style="border:0">
          <span>商品状态</span>
          <span
            style="color: #E02020;"
          >{{goodsinfo.state==6?'未发货':goodsinfo.state==7?'已发货':goodsinfo.state==8?'已收货':''}}</span>
        </div>
        <div class="moneyboxtop">
          <span>申请类型</span>
          <span
            style="color: #101010;"
          >{{type==0?'退货退款':type==1?'仅退款':type==2?'换货':type==3?'补偿':'补发'}}</span>
        </div>
      </div>
      <div class="bottoms">
        <div class="bottoms-top">
          <span>申请原因</span>
          <div class="right" @click="show1 = true">
            <div class="input" v-if="reason">{{reason}}</div>
            <div class="input grey" v-else>去选择</div>
            <img src="./../../assets/images/icon_youjiantou.svg" alt />
          </div>
        </div>
        <div class="bottoms-top" v-if="type==3">
          <span>补偿姓名</span>
          <div class="right">
            <input type="text" v-model="refund_name" placeholder="请填写补偿姓名(支付宝认证姓名)" />
          </div>
        </div>
        <div class="bottoms-top" v-if="type==3">
          <span>补偿账户</span>
          <div class="right">
            <input type="text" v-model="account" placeholder="请填写补偿账户(支付宝账户)" />
          </div>
        </div>
        <div class="bottoms-top" v-if="type==3">
          <span>补偿金额</span>
          <div class="right">
            <input type="text" ref="money" v-model="refundMoney" placeholder="请填写补偿金额" />
          </div>
        </div>
        <div class="bottoms-top" v-if="type ==0||type==1">
          <span>申请数量</span>
          <div class="right">
            <input type="text"  v-model="refundQuantity" :placeholder="'默认全部，最多可退'+goodsinfo.refund_quantity+'件'" @blur="blur"/>
          </div>
        </div>
        <div class="bottoms-top" v-else>
          <span>申请数量</span>
          <div class="right">
            <input type="text" placeholder="默认全部" disabled />
          </div>
        </div>
        <div class="bottoms-top" v-if="type=='2'">
          <span>选择换货规格</span>
          <div class="right" style="width:4.5rem" @click="guigeShow = true">
            <div class="input" v-if="guige">{{guige}}</div>
            <div class="input grey" v-else>去选择</div>
            <img src="./../../assets/images/icon_youjiantou.svg" alt />
          </div>
        </div>
        <div class="bottoms-top" v-if="goodsinfo.state ==7&&type!=2">
          <span>申请金额</span>
          <div class="right">
            <input type="text" ref="input" v-model="amount" :placeholder="'最多可退￥'+(applyRefundAmount||goodsinfo.commodity_amount)" />
          </div>
        </div>
        <p class="postageDesc" v-if="parseFloat(goodsinfo.postage||'0')>0&&goodsinfo.state ==7&&type!=2">产品已发货，发货运费￥{{goodsinfo.postage}}不可申请退款</p>
        <van-row class="upload" v-if="goodsinfo.state>6">
          <div class="uploadTitle">上传图片</div>
          <van-row type="flex" style="flex-wrap: wrap;margin-top:.2rem">
            <van-col class="img" v-for="(item,index) in imglist" :key="index">
              <img
                :src="item + `${imgCrop}resize,w_200`"
                @click="showImageArr(imglist,index)"
                alt
              />
              <img
                style="border:0"
                src="./../../assets/images/evaluate/close.png"
                alt
                class="colse"
                @click="delimg(index)"
              />
            </van-col>
            <!--上传图片的框子-->
            <van-uploader :after-read="upload" accept="image/*" v-if="imglist.length !=5">
              <van-row class="uploadbox">
                <img src="./../../assets/images/icon_plus2.png" alt />
              </van-row>
            </van-uploader>
          </van-row>
          <span class="text">最多上传5张图片</span>
        </van-row>
        <div class="bottoms-text">
          <p>问题描述</p>
          <textarea
            class="text"
            placeholder="请具体描述商品信息，最多200字"
            maxlength="200"
            @input="descInput"
            @blur="blurChange"
            v-model="message"
          />
          <span class="numberV">{{txtVal}}/200</span>
        </div>
      </div>
      <van-row class="bottom" @click.native="notice">
        <van-button type="danger" round :disabled="disabled" class="btn" @click="btn">提交申请</van-button>
      </van-row>
      <!--提交成功-->
      <van-popup v-model="show" :close-on-click-overlay="false">
        <van-row class="popup">
          <van-row
            type="flex"
            justify="center"
            align="center"
            style="flex-direction: column;height:2.51rem;"
          >
            <span style="margin-bottom:0.3rem;font-weight:bold;font-size:.34rem">申请提交成功</span>
            <span style="width:4.1rem;color:#F11313">我们会尽快完成审核,请耐心等候,可到售后退款中查看进度</span>
          </van-row>
        </van-row>
        <van-row>
          <van-col class="cancel" @click.native="sure">确定</van-col>
        </van-row>
      </van-popup>
      <!-- 退款原因选择 -->
      <van-popup class="bottompopup" v-model="show1" position="bottom">
        <div class="title">
          <span>选择申请原因</span>
        </div>
        <ul class="ullist">
          <li @click="xuanzhong(index)" v-for="(item,index) in ulList" :key="index">
            <span>{{item.refund_reason}}</span>
            <div class="paypopup-balancer">
              <img src="../../assets/images/icon_weixuan.svg" alt v-if="index != isindex" />
              <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
            </div>
          </li>
        </ul>
        <div class="bottom-btn" @click="show1 = false">
          <span>确定</span>
        </div>
      </van-popup>
    </div>

    <div class="guige-popup" v-show="guigeShow">
      <van-popup v-model="guigeShow" position="bottom" :overlay="true">
        <!--<div class="guige-popupbox">-->
        <div class="guige-popupt">
          <div class="guige-popuptl">
            <div class="guige-popuptll">
              <img v-if="assessmentDetail.inventoryLogo" :src=" assessmentDetail.inventoryLogo +`${imgCrop}resize,w_300`" alt/>
              <img v-else :src="goods_detail.commodityLogo +`${imgCrop}resize,w_300`" alt/>
            </div>
            <div class="guige-popuptlr">
              <p v-if="assessmentDetail[`sellPrice`]">￥{{ assessmentDetail[`sellPrice`] }}</p>
              <p v-else>￥{{ goods_detail[`minSellPrice`] }}</p>
              <p v-if="goods_detail.isQuantityShow == 1 && assessmentDetail.quantity">库存：{{ assessmentDetail.quantity }}</p>
              <p v-else-if="goods_detail.isQuantityShow == 1">库存：{{ quantity }}</p>
              <p v-else></p>
              <p v-show="guigeCount == selectArr.length"><span>请选择</span></p>
              <p v-show="guigeCount != selectArr.length">
                <span>已选：</span><span class="grey">{{ guige }}</span>
              </p>
            </div>
          </div>
          <div class="guige-popuptr" @click="guigeShow = false">
            <img src="../../assets/images/icon_close.svg" alt />
          </div>
        </div>
        <div class="guige-popupc-wrap">
          <div class="guige-popupc" v-for="(item, n) in propertyListJson" :key="n">
            <div class="guige-popupct">{{ item.name }}</div>
            <div class="guige-popupcc">
              <div
                class="guige-popupccm"
                v-for="(items, index) in item.children"
                :key="index"
                v-on:click="specificationBtn(item.name, items.name, items.quantity)"
                v-bind:class="
                  items.quantity == 0
                    ? 'nostock'
                    : [
                        JSON.stringify(selectArr).indexOf(
                          JSON.stringify({ key: item.name, value: items.name })
                        ) != -1
                          ? 'productActive'
                          : '',
                      ]
                "
              >
                <span>{{ items.name }}</span>
              </div>
              <!--noneActive-->
            </div>
          </div>
        </div>
        <div class="guige-popupnb">
          <div class="guige-popupnbr" @click="guigeShow=false">确定</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { photoCompress } from "../../assets/js/tool";
import { dataURLtoFile } from "../../assets/js/tool";
import { checkempty } from "./../../assets/js/tool";
import OSS from "ali-oss";
import ObsClient from "esdk-obs-browserjs/src/obs";
import weChatShareApi from "../../assets/js/weChatShare";

export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      nbr: this.$route.query.nbr, //小订单id
      parentNbr: this.$route.query.parentNbr, //大订单id
      type: this.$route.query.type,
      // status: this.$route.query.status,
      show: false,
      show1: false,
      goodsinfo: "",
      message: "",
      disabled: true,
      imglist: [],
      reasonshow: false,
      reason: "",
      money: "",
      account: "",
      refund_name:'',
      refundQuantity:'',
      refundMoney:'',
      amount:'',
      txtVal: 0,
      isindex: -1,
      reg: /^(\d?)+(\.\d{0,2})?$/,
      ulList: [
        { refund_reason: "颜色/尺寸/参数不符" },
        { refund_reason: "商品瑕疵" },
        { refund_reason: "质量问题" },
        { refund_reason: "少件/漏发" },
        { refund_reason: "其他" }
      ],
      guigeShow:false,
      guige:'',
      goods_detail: {
        commodityInventoryList: [{}],
      },
      quantity:'',
      assessmentDetail: {},
      guigeCount: 0,
      quantityArr: [],
      selectArr: [],
      propertyListJson: [],
      applyRefundAmount:'',
      isRequired:false,
    };
  },
  watch: {
    amount(val, old) {
      if (!val) {
        return;
      }
      if (this.reg.test(val)==true) {
        this.$refs.input.value = val;
      } else {
        this.$refs.input.value = val.substring(0, val.length - 1);
        val = this.$refs.input.value;
      }
      let maxAmount =  this.applyRefundAmount?parseFloat(this.applyRefundAmount):parseFloat(this.goodsinfo.commodity_amount)
      if (parseFloat(val) > maxAmount) {
        val = parseFloat(maxAmount).toFixed(2);
        this.$toast("金额不能大于最大退款金额");
      }
      this.amount = val;
      this.check();
    },
    refundMoney(val, old){
      if (!val) {
        return;
      }
      if (this.reg.test(val)==true) {
        this.$refs.money.value = val;
      } else {
        this.$refs.money.value = val.substring(0, val.length - 1);
        val = this.$refs.money.value;
      }
      this.refundMoney = val;
      this.check();
    },
    refundQuantity(){
      this.check();
    },
    reason() {
      this.check();
    },
    message() {
      this.check();
    },
    account(){
      this.check();
    },
    refund_name(){
      this.check();
    },
  },
  methods: {
    blur(){
      if(this.refundQuantity){
        this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_40064",
            commodity_record_nbr: this.nbr,
            refund_quantity: this.refundQuantity, 
          }
        })
          .then(resp => {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
                this.applyRefundAmount = resp.commodity_amount;
              } else {
                this.applyRefundAmount = '';
                this.$toast({
                  message: resp.resp_msg,
                  duration: 2000
                });
              }
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          }); 
      }else{
        this.applyRefundAmount = '';
      }
    },
    blurChange() {
      window.scrollTo(0, 0);
    },
    ifMoney() {
      if (parseFloat(this.money) > parseFloat(this.goodsinfo.sum_amount)) {
        this.money = this.goodsinfo.sum_amount;
      }
    },
    notice(){
      if(this.disabled){
        this.$toast({
          message: '请补全申请资料',
          duration: 2000
        });
      }
    },
    /**
     * 选择退款原因
     */
    xuanzhong(index) {
      this.reason = this.ulList[index].refund_reason;
      this.isRequired = this.ulList[index].is_required=='1';
      this.isindex = index;
    },
    /**
     * 字数 0/200
     */
    descInput() {
      this.txtVal = this.message.length;
    },
    /**
     * 检查是否全填，全部填写后可以按按钮
     */
    check() {
      const that = this;
      let arr = [];
      that.type == 3
        ? (arr = [
            { val: that.reason, toast: "请选择原因" },
            { val: that.refund_name, toast: "请填写补偿账号姓名" },
            { val: that.account, toast: "请填写补偿账户" },
            { val: that.refundMoney, toast: "请填写补偿金额" },
            { val: that.message, toast: "请填写退款说明" }
          ])
        :(arr = [
            { val: that.reason, toast: "请选择原因" },
            { val: that.message, toast: "请填写退款说明" }
          ]);

      let result = true;
      for (var index = 0; index < arr.length; index++) {
        if (!checkempty(arr[index].val)) {
          result = false;
          break;
        }
      }
      if (!result) {
        this.disabled = true;
        return;
      }
      this.disabled = false;
    },
    upload(file) {
      const that = this;
      let toast = this.$toast.loading({
        duration: 0
      });
      let quality = Number((1048576 / file.file.size).toFixed(1)); //压缩到1m以内  算出压缩比例
      photoCompress(file.file, callback, quality); //将图片进行压缩
      function callback(res) {
        let newFile = dataURLtoFile(res, file.file.name);
        let url = that.uploadPath("images/refund", newFile);
        if(that.uplaodServer=='aliyun'){
        that.$post("/api/customer/getOSSToken", {
            userNbr: that.userInfo.nbr,
            token: "123456"
          })
          .then(data => {
            let OSSToken = data.object.resp;
            if (OSSToken.resp_code == 0 && OSSToken.resp_result == 0) {
              let client = new OSS({
                //            region: '购买的区域',
                endpoint: OSSToken.endpoint,
                bucket: OSSToken.bucketName,
                accessKeyId: OSSToken.accessKeyId,
                accessKeySecret: OSSToken.accessKeySecret,
                stsToken: OSSToken.securityToken
              });
              client.options.endpoint.protocol = "https:";
              client
                .put(url, newFile)
                .then(data => {
                  let imgUrl = that.cdnImgPath + "/" + data.name;
                  that.imglist.push(imgUrl);
                  that.$forceUpdate();
                  toast.clear();
                })
                .catch(error => {
                  toast.clear();
                  that.$toast({
                    message: "上传失败",
                    duration: 2000
                  });
                });
            } else {
              that.$toast({
                message: OSSToken.resp_msg,
                duration: 2000
              });
            }
          })
          .catch(err => {
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
        }else{
          that.$post("/api/customer/getObsToken", {
            userNbr: that.userInfo.nbr,
            token: "123456",
          })
          .then((data) => {
            let OBSToken = data.object.resp;
            if (OBSToken.resp_code == 0 && OBSToken.resp_result == 0) {
              let client = new ObsClient({
                access_key_id: OBSToken.accessKeyId,
                secret_access_key: OBSToken.accessKeySecret,
                server: OBSToken.endpoint,
                security_token: OBSToken.securityToken,
                timeout: 3000, // 设置超时时间
              });
              client.putObject(
                {
                  Bucket: OBSToken.bucketName, // 桶名
                  Key: url, // 文件名
                  SourceFile: newFile,
                },
                function (err, result) {
                  if (err) {
                    toast.clear();
                    that.$toast({
                      message: "上传失败",
                      duration: 2000,
                    });
                  } else {
                    if (result.CommonMsg.Status < 300) {
                      let imgUrl = that.cdnImgPath + "/" + url;
                      that.imglist.push(imgUrl);
                      that.$forceUpdate();
                      toast.clear();
                    }
                  }
                }
              );
            } else {
              that.$toast({
                message: OBSToken.resp_msg,
                duration: 2000,
              });
            }
          })
          .catch((err) => {
            that.$toast({
              message: err.message,
              duration: 2000,
            });
          });
        }
      }
    },
    uploadPath(path, file) {
      //let name = file.name.replace("wxfile://", "");
      return `${path}/${this.userInfo.nbr}-${new Date().getTime()}.${
        file.type.split("/")[1]
      }`;
    },
    showImageArr(img, index) {
      wx.previewImage({
        current: img[index],
        urls: img
      });
    },
    delimg(index) {
      this.imglist.splice(index, 1);
    },
    sure() {
      this.show = false;
      this.$store.commit("SENDpayment", 1);
      this.$router.go(-2);
    },
    getReason() {
      this.$commonPost({
        jydm: "flow_40031",
        flow_40031: {
          state: 0
        }
      })
        .then(resp => {
          let arr = [];
          if (resp.list) {
            if (resp.list.length > 0) {
              arr = resp.list;
            } else {
              arr.push(resp.list);
            }
          }
          if(arr.length > 0) this.ulList = arr;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getUserAllInfo(){
      this.$commonPost({
        jydm: "flow_10018",
        flow_10018: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(resp => {
          this.refund_name = resp.name||'';
          this.account = resp.account||'';
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    btn() {
      if(this.refundQuantity&&Number(this.refundQuantity)>Number(this.goodsinfo.refund_quantity)){
        this.$toast({
          message: '退款数量不能多于'+this.goodsinfo.refund_quantity+'件',
          duration: 2000
        });
        return false;
      }
      let imgText = "";
      let type = "";
      let imgArr = this.imglist;
      if(this.goodsinfo.state>6 && this.isRequired && imgArr.length<=0) return this.$toast({
          message: '请上传图片',
          duration: 2000
        });
      for (let i = 0; i < imgArr.length; i++) {
        if (i == 0) {
          imgText += imgArr[i];
        } else {
          imgText += "," + imgArr[i];
        }
      }
      let toast = this.$toast.loading({
        mask: true,
        duration: 0
      });
      if (this.$route.query.type == 0) {
        type = 3;
      } else if (this.$route.query.type == 1) {
        type = 2;
      } else if (this.$route.query.type == 2) {
        type = 5;
      } else if (this.$route.query.type == 3) {
        type = 6;
      } else if (this.$route.query.type == 4) {
        type = 7;
      }

      if(type==5 && this.assessmentDetail.nbr && parseFloat(this.assessmentDetail.sellPrice)!=parseFloat(this.goodsinfo.old_price) ){
        return this.$toast({
          message: '只能退换同价格的规格商品',
          duration: 2000
        });
      }

      let newMessage = this.message
      if(this.assessmentDetail.nbr){
        newMessage = `${newMessage}(${this.assessmentDetail.propertyComplete})`
      }
      if (this.goodsinfo.state == 6) {
        this.$post("/api/customer/refundOrder/recordApplyConfirm", {
            userNbr: this.userInfo.nbr,
            commodityRecordNbr: this.nbr,
            refundQuantity: this.refundQuantity||0,
            refundReason: this.reason,
            refundNote: newMessage
          })
          .then(res => {
            if (res.code == "200") {
              let resp = res.object.resp;
              if (resp.resp_code == "0" && resp.resp_result == "0") {
                toast.clear();
                this.show = true;
              } else {
                this.$toast({
                  message: resp.resp_msg,
                  duration: 2000
                });
              }
            } else {
              this.$toast({
                message: res.data.message,
                duration: 2000
              });
            }
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      } else if (this.goodsinfo.state == 7&& type!=5) {
        this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_40034",
            refund_type: type,
            refund_reason: this.reason,
            refund_note: newMessage,
            refund_image: imgText,
            commodity_record_nbr: this.nbr,
            amount: this.amount,
            refund_quantity: this.refundQuantity||'',
            build:'96',
          }
        })
          .then(resp => {
            toast.clear();
            this.show = true;
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      } else if ((this.goodsinfo.state == 7&& type==5)||this.goodsinfo.state == 8) {
        let obj = {
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_40035",
            refund_type: type,
            refund_reason: this.reason,
            refund_note: newMessage,
            refund_image: imgText,
            repay_amount: this.refundMoney,
            commodity_record_nbr: this.nbr,
            build:'96',
          }
        };
        if (type == 6){
          obj.flow_10000.refund_account = this.account;
          obj.flow_10000.refund_name = this.refund_name;
        }
        this.$commonPost(obj)
          .then(resp => {
            toast.clear();
            this.show = true;
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      }
    },
    initPage() {
      if (this.$route.query.supNbr == this.userInfo.nbr) {
        // 获取信息
        this.$commonPost({
          jydm: "flow_40005",
          flow_40005: {
            nbr: this.nbr
          }
        })
          .then(resp => {
            this.goodsinfo = resp;
            if(this.$route.query.type==2){
              this.getCommodity(resp.commodity_nbr)
            }
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
        this.getReason();
        if(this.$route.query.type=='3'){
          this.getUserAllInfo()
        }
      } else {
        return this.$router.push({
          path: "index",
          query: { supNbr: this.userInfo.nbr }
        });
      }
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
    },
    getCommodity(nbr){
      this.$post("/api/customer/queryCommodityDetail", {
          commodityNbr: nbr
        })
        .then(res => {
          let data = res.object.resp.commodity;
          if (res.code == "200") {
            let resp = res.object.resp;
            this.getCommodityNum(data.nbr)
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              this.propertyListJson = data.propertyJson;
              this.goods_detail = data;
              this.guigeCount = data.propertyJson.length;
              let propertyArr = [];
              data.propertyJson.map((item, j) => {
                let obj = {
                  key: item.name,
                  value: "",
                };
                propertyArr.push(obj);
              });
              this.guige = '';
              this.selectArr = propertyArr;
              this.checkItem(propertyArr);
              this.checkNoClick();
              this.thisCheckNoClick(propertyArr);
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
            }
          } else {
            this.$toast({
              message: resp.message,
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getCommodityNum(nbr){
      this.$commonPost({
      jydm: "flow_70059",
      flow_70059: {
        nbr: nbr,
        wechat_version: 1
      }
    })
      .then(response => {
        this.quantity = response.commodity.quantity;
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
    },
    specificationBtn: function (key, value, num) {
      let text = "";
      let selectArr = this.selectArr;
      if (num == 0) {
        return this.$toast({
          message: "该规格库存为0",
          duration: 2000,
        });
      }
      selectArr.map((item, index) => {
        if (item.key == key) {
          if (item.value == value) {
            selectArr[index].value = "";
          } else {
            selectArr[index].value = value;
          }
        }
      });
      let dIndex = 0;
      for (let i = 0; i < selectArr.length; i++) {
        if (selectArr[i].value != "") {
          if (i == dIndex) {
            text = selectArr[i].value;
          } else {
            text += "," + selectArr[i].value;
          }
        } else {
          dIndex += 1;
        }
      }
      let assessmentDetail = this.assessmentDetail;
      let goods_detail = this.goods_detail;
      let propertyListJson = this.propertyListJson;
      let checkPriceChange = this.checkPriceChange;
      let count = 0;
      selectArr.map((item) => {
        if (item.value == "" || !item.value) {
          count += 1;
        }
      });
      this.thisCheckNoClick(selectArr);
      this.guigeCount = count;
      this.guige = text;
      this.selectArr = selectArr;
      let inventoryList = [];
      if (count == selectArr.length) {
        assessmentDetail.minimumSellNum = 1;
        assessmentDetail.addStep = 1;
        assessmentDetail.inventoryLogo = goods_detail.commodityLogo;
        assessmentDetail.directorPrice = checkPriceChange(
          goods_detail.minDirectorPrice,
          goods_detail.maxDirectorPrice
        );
        assessmentDetail.agentPrice = checkPriceChange(
          goods_detail.minAgentPrice,
          goods_detail.maxAgentPrice
        );
        assessmentDetail.sellPrice = checkPriceChange(
          goods_detail.minSellPrice,
          goods_detail.maxSellPrice
        );
        assessmentDetail.quantity = this.quantity;
        this.assessmentDetail = assessmentDetail;
      } else if (count > 0) {
        let propertyList = this.goods_detail.commodityInventoryList;
        let propertyArr = [];
        for (let a = 0; a < selectArr.length; a++) {
          if (selectArr[a].value) {
            let aItem = {
              propertyName: selectArr[a].key,
              propertyValue: selectArr[a].value,
            };
            propertyArr.push(aItem);
          }
        }
        for (let b = 0; b < propertyList.length; b++) {
          let bItem = propertyList[b].propertyListJson;
          let count = 0;
          for (let c = 0; c < propertyArr.length; c++) {
            if (
              JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) !=
              -1
            ) {
              count += 1;
            }
          }
          if (count == propertyArr.length) {
            inventoryList.push(propertyList[b]);
          }
        }
        this.assessmentDetail = JSON.parse(JSON.stringify(inventoryList[0]));
      } else {
        this.checkItem(selectArr);
      }
    },
    checkPriceChange(a, b) {
      if (a == b) {
        return a;
      } else {
        return a + "-" + b;
      }
    },
    checkItem: function (selectArr) {
      let propertyArr = [];
      let propertyList = this.goods_detail.commodityInventoryList;
      for (let a = 0; a < selectArr.length; a++) {
        let aItem = {
          propertyName: selectArr[a].key,
          propertyValue: selectArr[a].value,
        };
        propertyArr.push(aItem);
      }
      for (let b = 0; b < propertyList.length; b++) {
        let bItem = propertyList[b].propertyListJson;
        let count = 0;
        for (let c = 0; c < propertyArr.length; c++) {
          if (
            JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) != -1
          ) {
            count += 1;
          }
        }
        if (count == bItem.length) {
          this.assessmentDetail = JSON.parse(JSON.stringify(propertyList[b]));

        }
      }
      this.$forceUpdate(); //重绘
    },
    checkNoClick: function () {
      let propertyList = this.goods_detail.commodityInventoryList;
      let quantityArr = [];
      for (let i = 0; i < propertyList.length; i++) {
        if (propertyList[i].quantity == 0) {
          let propertyComplete = propertyList[i].propertyListJson;
          quantityArr.push(propertyComplete);
        }
      }
      this.quantityArr = quantityArr;
    },
    thisCheckNoClick(selectArr) {
      let quantityArr = this.quantityArr;
      let propertyListJson = this.propertyListJson;
      propertyListJson.map((json, index1) => {
        json.children.map((child, index2) => {
          let arr = [];
          arr.length = propertyListJson.length;
          arr[index1] = {
            propertyName: json.name,
            propertyValue: child.name,
          };
          selectArr.map((select, index3) => {
            if (index3 != index1) {
              arr[index3] = {
                propertyName: select.key,
                propertyValue: select.value,
              };
            }
          });
          if (JSON.stringify(quantityArr).indexOf(JSON.stringify(arr)) > 0) {
            child.quantity = 0;
          } else {
            child.quantity = 1;
          }
        });
      });
      this.propertyListJson = propertyListJson;
    },
  },
  created() {
    document.title = "申请售后";
    this.initPage();
  },
  mounted() {}
};
</script>
<style scoped lang='stylus'>
.upload >>> .van-uploader__input {
  border-radius: 0.08rem;
}
</style>
<style scoped lang='less'>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}
.moneybox {
  width: 100%;
  padding: 0.4rem 0;
  margin: 0 auto;
  margin-top: 0.2rem;
  background: #ffffff;
  overflow: hidden;
  border-bottom: 1px solid #eeeeee;
  .moneyboxtop {
    margin: 0 0.27rem;
    font-size: 0.3rem;
    color: #333333;
    font-weight: 500;
    margin-bottom: 0.3rem;
    line-height: 0.42rem;
    display: flex;
    justify-content: space-between;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.bottoms {
  background: #ffffff;
  font-size: 0.3rem;
  padding: 0.4rem 0 0;
  .bottoms-top {
    margin: 0 0.27rem 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .right {
      display: flex;
      align-items: center;
      .input{
        color: #333;
        width: 5.15rem;
        display: flex;
        justify-content: flex-end;
        &.grey{
          color: #999;
        }
      }
      input {
        border: 0;
        background: #ffffff;
        text-align: end;
        width: 5.15rem;
        color:#333;
        &::-webkit-input-placeholder {
          /* WebKit, Blink, Edge */
          color: #999;
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999;
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999;
        }
        &::-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #999;
        }
      }
    }
  }
  .postageDesc{
    box-sizing: border-box;
    padding-left: .3rem;
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.33rem;
    margin-top: -.1rem;
  }
  .bottoms-text {
    margin: 0.24rem;
    margin-bottom: 0;
    position: relative;
    .numberV {
      position: absolute;
      right: 0.3rem;
      bottom: 0.2rem;
    }
    p {
      font-size: 0.3rem;
      color: #333;
      line-height: 0.42rem;
    }
    .text {
      width: 6.93rem;
      height: 2.2rem;
      margin-top: 0.2rem;
      margin-left: calc((100% - 6.93rem) / 2);
      border: 0;
      font-size: 0.24rem;
      color: #333333;
      line-height: 0.33rem;
      border-radius: 0.1rem;
      padding: 0.2rem;
      box-sizing: border-box;
      background: #f5f5f5;
    }
    textarea::-webkit-input-placeholder {
      color: #999;
    }
    span {
      font-size: 0.24rem;
      color: #999999;
      display: flex;
      justify-content: flex-end;
    }
  }
}
.mid {
  margin-top: 0.2rem;
  .list {
    position: relative;
    height: 0.96rem;
    .van-cell {
      height: 100%;
      padding: 0.2rem 0.28rem;
    }

    img {
      position: absolute;
      top: 0.32rem;
      right: 0.28rem;
    }
  }
}

.input {
  .van-cell {
    height: 100%;
    padding: 0.2rem 0.28rem;
  }
}
.upload {
  background: #ffffff;
  margin: 0 0.24rem;
  margin-top: 0.22rem;
  .uploadTitle {
    font-size: 0.3rem;
    color: #333;
    line-height: 0.42rem;
  }
  .text {
    margin-top: 0.2rem;
    font-size: 0.24rem;
    color: #999999;
    display: block;
  }
  .title {
    font-size: 0.28rem;
    color: #333333;
  }
  .img {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.24rem;
    border-radius: 0.08rem;
    position: relative;
    &:last-child {
      margin-right: 0;
    }
    img {
      width: 100%;
      height: 100%;
      position: relative;
      border-radius: 0.08rem;
      object-fit: cover;
      border: 1px solid #dedede;
      box-sizing: border-box;
    }
    .colse {
      width: 0.4rem;
      height: 0.4rem;
      position: absolute;
      top: -0.14rem;
      right: -0.06rem;
    }
  }
  .uploadbox {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 0.08rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.24rem;
    color: #bbbbbb;
    img {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 0.08rem;
      box-sizing: border-box;
    }
  }
}

.bottom {
  width: 100%;
  box-sizing: border-box;
  padding: 0.33rem 0.32rem 0.25rem;
  background: #ffffff;
  .btn {
    width: 100%;
    height: 0.88rem;
    font-size: 0.32rem;
  }
  .van-button--disabled {
    border: 1px solid #ffc5c3;
    color: #fff;
    background: #ffc5c3;
  }
  .van-button--danger {
    color: #fff;
    background: #e52b25;
    border: 1px solid #e52b25;
  }
}
.topCommodity {
  width: 100%;
  height: 3.4rem;
  background: #fff;
  justify-content: center;
  align-items: center;
  display: flex;
}
.commodity {
  width: 6.9rem;
  padding: 0.26rem 0.32rem;
  background: #f1f1f1;
  box-sizing: border-box;
  img {
    width: 2.36rem;
    height: 2.36rem;
    object-fit: cover;
  }
  .rightArea {
    margin-left: 0.2rem;
    position: relative;
    flex: 1;
    .commodityName {
      font-size: 0.3rem;
      font-weight: 500;
      color: #333;
      line-height: 0.36rem;
    }
    .property {
      margin-top: 0.1rem;
      font-size: 0.22rem;
      font-weight: 500;
      color: #999;
      line-height: 0.3rem;
    }
    .last {
      position: absolute;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .price {
        font-size: 0.3rem;
        color: #e52b25;
        font-weight: 500;
      }
      .quantity {
        font-size: 0.24rem;
        color: #333;
        font-weight: bold;
      }
    }
  }
}

.reason {
  border-radius: 0 !important;
}

/*提交成功*/
.van-popup {
  border-radius: 0.18rem;
  .popup {
    width: 6.14rem;
    height: 2.51rem;
    border-bottom: 1px solid #eeeeee;
    .title {
      font-size: 0.32rem;
      color: #333333;
    }
    .content {
      /*height: 1.6rem;*/
      text-align: center;
      font-size: 0.28rem;
      color: #999999;
    }
  }
  .cancel {
    height: 0.96rem;
    text-align: center;
    line-height: 0.96rem;
    width: 100%;
    background: #ffffff;
    font-size: 0.32rem;
    color: #333333;
  }
}
.bottompopup {
  background: #ffffff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  .title {
    font-weight: bold;
    font-size: 0.3rem;
    color: #333333;
    height: 0.88rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.1rem;
  }
  .ullist {
    height: 5.28rem;
    margin-top: 0.53rem;
    overflow-y: auto;
    overflow-x: hidden;
    li {
      height: 0.88rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 0.24rem;
      span {
        font-weight: 400;
        font-size: 0.28rem;
        color: #333333;
      }
      img {
        margin-right: 0.3rem;
      }
      .paypopup-balancer img {
        width: 0.42rem;
      }
    }
  }
  .bottom-btn {
    height: 0.98rem;
    margin-top: 0.2rem;
    background: #e52b25;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.3rem;
      color: #ffffff;
    }
  }
}

.guige-popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  height: 100vh;
  display: flex;
  align-items: flex-end;
  width: 100%;
}
.guige-popupbox {
  margin-top: calc(100vh - 9.48rem);
  background: #ffffff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.guige-popupt {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 0.24rem;
  margin-top: 0.24rem;
}

.guige-popuptl {
  display: flex;
  flex-direction: row;
}

.guige-popuptlr {
  margin-left: 0.24rem;
}

.guige-popuptlr p:nth-of-type(1) {
  color: #E52B25;
  font-size: 0.4rem;
  margin-top: 0.1rem;
}

.guige-popuptlr p:nth-of-type(2) {
  font-size: 0.24rem;
  margin-top: 0.1rem;
  line-height: 0.35rem;
  color: #999;
}

.guige-popuptlr p:nth-of-type(3) {
  font-size: 0.24rem;
  margin-top: 0.1rem;
  width: 4.72rem;
  line-height: 0.35rem;
  display: flex;
  justify-content: flex-start;
  span{
    height:100%;
  }
}
.guige-popuptlr p:nth-of-type(4) {
  font-size: 0.24rem;
  margin-top: 0.1rem;
  width: 4.72rem;
  line-height: 0.35rem;
  display: flex;
  justify-content: flex-start;
  span{
    height:100%;
  }
}
.guige-popuptr{
  position: absolute;
  top: .24rem;
  right:.24rem;
  img{
    width: 0.4rem;
  }
}
.guige-popuptr img{
  width:0.4rem;
  height:0.4rem;
}
.guige-popuptll img {
  width: 2rem;
  height: 2rem;
  border-radius: 0.08rem;
  object-fit: cover;
}

.guige-popupc-wrap {
  width: 100%;
  margin-top: 0.2rem;
  height: 4.8rem;
  box-sizing: border-box;
  padding-bottom: .2rem;
  overflow-y: auto;
}

.guige-popupct {
  font-size: 0.28rem;
  margin-left: 0.24rem;
  margin-top: 0.4rem;
}

.guige-popupcc {
  width: calc(100% - .24rem);
  margin-left: .12rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.guige-popupccm {
  padding: 0.05rem 0.25rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0.5rem;
  margin-right: 0.12rem;
  margin-left: 0.12rem;
  margin-top: 0.24rem;
  border: 1px solid #999;
  font-size: 0.24rem;
  line-height: .34rem;
  span{
    display: inline-block;
    line-height: 0.34rem;
    word-break:break-all;
  };
}

.guige-popupcc .productActive {
  background-color: #E52B25 !important;
  color: #fff !important;
  border: 1px solid #E52B25 !important;
  box-sizing: border-box;
}

.guige-popupcc .noneActive {
  background-color: #ccc !important;
  opacity: 0.4 !important;
  color: #000 !important;
  pointer-events: none !important;
}

.guige-popupnb {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /*position: absolute;*/
  /*bottom: 0;*/
  /*left: 0;*/
  margin-top: 0.12rem;
}

.guige-popupnbr {
  width: 100%;
  text-align: center;
  line-height: .98rem;
  font-size: 0.3rem;
  color: #fff;
  background: #E52B25;
}
</style>



// WEBPACK FOOTER //
// src/components/information/replacement.vue